import { createRouter, createWebHistory } from 'vue-router'
import PortalLayout from "../layout/PortalLayout.vue";
// import NotFoundPage from "../pages/NotFoundPage.vue";
import AuthorizationPage from "../pages/AuthorizationPage.vue";
import NotificationsPage from "../pages/NotificationsPage.vue";
import OrdersPage from "../pages/OrdersPage.vue";
import SearchPage from "../pages/SearchPage.vue";
import ClaimsPage from "../pages/ClaimsPage.vue";
import ReportsPage from "../pages/ReportsPage.vue";
import AppealsPage from "../pages/AppealsPage.vue";
import KPPage from "../pages/KPPage.vue";
import PricePage from "../pages/PricePage.vue";
import ProfilePage from "../pages/ProfilePage.vue";
import OrderCreatePage from "../pages/OrderCreatePage.vue";
import OrderDetailPage from "../pages/OrderDetailPage.vue";
import ClaimCreatePage from "../pages/ClaimCreatePage.vue";
import AppealCreatePage from "../pages/AppealCreatePage.vue";
import KPDetailPage from "../pages/KPDetailPage.vue";
import PLDetailPage from "../pages/PLDetailPage.vue";

const routes = [
  {
    path: "/",
    component: PortalLayout,
    redirect: "/orders",
    children: [
      {
        path: "/notifications",
        name: "notifications",
        component: NotificationsPage,
        meta: {
          title: "Уведомления",
        },
      },
      {
        path: "/orders",
        name: "orders",
        component: OrdersPage,
        meta: {
          title: "Заказы",
        },
      },
      {
        path: "/order/search",
        name: "order/search",
        component: SearchPage,
        meta: {
          title: "Результаты поиска по номеру документа",
        },
      },
      {
        path: "/kp/detail",
        name: "kp/detail",
        component: KPDetailPage,
        meta: {
          title: "Коммерческое предложение",
        },
      },
      {
        path: "/price/detail",
        name: "price/detail",
        component: PLDetailPage,
        meta: {
          title: "Прайс-лист",
        },
      },
      {
        path: "/order/detail",
        name: "order/detail",
        component: OrderDetailPage,
        meta: {
          title: "Заказ",
        },
      },
      {
        path: "/order/create",
        name: "order/create",
        component: OrderCreatePage,
        meta: {
          title: "Создание заказа",
        },
      },
      {
        path: "/claim/create",
        name: "claim/create",
        component: ClaimCreatePage,
        meta: {
          title: "Создание претензии",
        },
      },
      {
        path: "/appeal/create",
        name: "appeal/create",
        component: AppealCreatePage,
        meta: {
          title: "Создание обращения",
        },
      },
      {
        path: "/claims",
        name: "claims",
        component: ClaimsPage,
        meta: {
          title: "Претензии",
        },
      },
      {
        path: "/reports",
        name: "reports",
        component: ReportsPage,
        meta: {
          title: "Отчеты",
        },
      },
      {
        path: "/appeals",
        name: "appeals",
        component: AppealsPage,
        meta: {
          title: "Обращения",
        },
      },
      {
        path: "/kp",
        name: "kp",
        component: KPPage,
        meta: {
          title: "Коммерческие предложения",
        },
      },
      {
        path: "/price",
        name: "price",
        component: PricePage,
        meta: {
          title: "Прайс-лист",
        },
      },
      {
        path: "/profile",
        name: "profile",
        component: ProfilePage,
        meta: {
          title: "Профиль пользователя",
        },
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: "Авторизация",
    },
    component: AuthorizationPage,
  },
  // { path: "*", component: NotFoundPage },
];

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router;
